import { useAuth } from '~/plugins/auth'

export function useDatasource () {
  const { getInventoryReport } = inject('actions')
  const auth = useAuth()
  const error = ref(false)
  const loading = ref(false)
  const count = ref(0)

  const dataSource = {
    allData: []
  }

  const fetchReportRecursively = async (after = '', first = 1000) => {
    const { data } = await getInventoryReport.fetch({
      after,
      first,
      id: auth.dealerId
    })

    data.dealer.inventory.edges.forEach(({ node }) => {
      if (!node.acvValues?.guarantee || !node.price?.unitCost?.amount) return
      dataSource.allData.push(node)
    })

    count.value = dataSource.allData.length

    const { pageInfo: { hasNextPage, endCursor } } = data.dealer.inventory
    if (hasNextPage) await fetchReportRecursively(endCursor, first)
  }

  const fetchReport = async () => {
    dataSource.allData = []
    count.value = 0
    loading.value = true
    error.value = false

    try {
      await fetchReportRecursively('', 1000)
    } catch {
      error.value = true
    } finally {
      loading.value = false
    }
  }

  return {
    count,
    error,
    fetchReport,
    dataSource,
    loading
  }
}
